export const SPEAKER_STATS_RELOAD_INTERVAL = 1000;

export const DISPLAY_SWITCH_BREAKPOINT = 600;

export const RESIZE_SEARCH_SWITCH_CONTAINER_BREAKPOINT = 750;

export const MOBILE_BREAKPOINT = 480;
